(() => {
  const PAGE_SIZE = 24;
  const STORE = "https://mannacrockery.pk";
  const STORE_API = ""; // same-origin Shopify JSON first
  const SHOP_MODE = document.body.dataset.shopMode || "shop";
  const IS_NEW_PAGE = SHOP_MODE === "new";
  const NEW_WITHIN_DAYS = 120;
  let catalogTotal = 0;
  const iconHeart = `<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M8 14s-5-3.1-5-6.5A2.8 2.8 0 018 5.3a2.8 2.8 0 015 2.2C13 10.9 8 14 8 14z"/></svg>`;
  const iconCmp = `<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.5 4.5 3.5 7.5 6.5 10.5"/><path d="M3.5 7.5h7"/><path d="M13.5 15.5 16.5 12.5 13.5 9.5"/><path d="M16.5 12.5h-7"/></svg>`;
  const iconBook = `<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5.5h10.5l-1.1 7.2H4.2L3 5.5z"/><path d="M5.5 5.5V4.4a2.5 2.5 0 015 0v1.1"/><circle cx="6.2" cy="14.2" r="0.9"/><circle cx="11.3" cy="14.2" r="0.9"/></svg>`;

  const productMap = new Map(Object.entries(JSON.parse(localStorage.getItem("mana_products") || "{}")));

  const shop = {
    cart: JSON.parse(localStorage.getItem("mana_cart") || "[]"),
    wish: JSON.parse(localStorage.getItem("mana_wish") || "[]"),
    compare: JSON.parse(localStorage.getItem("mana_compare") || "[]")
  };

  let collections = [];
  let departments = [];
  let products = [];
  let pageItems = [];
  let arrivalsPool = [];
  let totalCount = 0;
  let remotePaging = true;
  let state = readState();
  let compareOpen = false;
  let fetchToken = 0;
  let fetchAbort = null;
  const pageCache = new Map();
  const SORT_POOL = 96;

  function readState() {
    const q = new URLSearchParams(location.search);
    if (IS_NEW_PAGE) {
      const tab = q.get("tab") || "all";
      return {
        collection: "all",
        tab: ["all", "new", "deals"].includes(tab) ? tab : "all",
        sort: q.get("sort") || "newest",
        page: Math.max(1, Number(q.get("page")) || 1)
      };
    }
    const root = document.querySelector("[data-mana-shop]");
    const shopifyCol = (root && root.dataset.collection) || "all";
    return {
      collection: q.get("collection") || (shopifyCol !== "all" ? shopifyCol : "all"),
      tab: "all",
      sort: q.get("sort") || "featured",
      page: Math.max(1, Number(q.get("page")) || 1)
    };
  }

  function writeState() {
    const q = new URLSearchParams();
    // Keep Shopify alternate template (?view=) so refresh stays on New/Shop mirror
    const view = new URLSearchParams(location.search).get("view");
    if (view) q.set("view", view);
    if (IS_NEW_PAGE) {
      if (state.tab && state.tab !== "all") q.set("tab", state.tab);
      if (state.sort && state.sort !== "newest") q.set("sort", state.sort);
    } else {
      if (state.collection && state.collection !== "all") q.set("collection", state.collection);
      if (state.sort && state.sort !== "featured") q.set("sort", state.sort);
    }
    if (state.page > 1) q.set("page", String(state.page));
    const next = q.toString();
    const url = next ? `${location.pathname}?${next}` : location.pathname;
    history.replaceState(null, "", url);
  }

  function shopImage(src, width = 400) {
    if (!src) return "";
    if (src.startsWith("/") || src.startsWith("data:") || src.startsWith("blob:")) return src;
    let out = src.replace("https://cdn.shopify.com/s/files/1/0705/6483/9574/", "https://cdn.shopify.com/s/files/1/0705/6483/9574/");
    if (/[?&]width=/.test(out)) out = out.replace(/([?&]width=)\d+/g, `$1${width}`);
    else out += (out.includes("?") ? "&" : "?") + `width=${width}`;
    return out;
  }

  function money(n) {
    return `Rs.${Number(n).toLocaleString("en-PK")}`;
  }

  function parsePrice(raw) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return 0;
    return n > 9999 && String(raw).includes(".") === false ? Math.round(n / 100) : Math.round(n);
  }

  function normalizeProduct(p) {
    const variant = (p.variants && p.variants[0]) || {};
    const amount = parsePrice(variant.price);
    const compareRaw = variant.compare_at_price;
    const compare = compareRaw ? parsePrice(compareRaw) : 0;
    const first = (p.images && p.images[0]) || null;
    const img = shopImage(first ? (first.src || first) : "", 400);
    const publishedAt = p.published_at || p.created_at || "";
    const publishedMs = publishedAt ? Date.parse(publishedAt) : 0;
    const isDeal = compare > amount;
    const isNew = publishedMs > 0 && (Date.now() - publishedMs) <= NEW_WITHIN_DAYS * 86400000;
    const item = {
      id: p.handle || String(p.id),
      title: p.title,
      amount,
      price: money(amount),
      compare: isDeal ? money(compare) : "",
      sale: isDeal ? `-${Math.round((1 - amount / compare) * 100)}%` : "",
      badge: !isDeal && isNew ? "New" : "",
      isDeal,
      isNew,
      publishedMs,
      img,
      images: img ? [img] : [],
      desc: "",
      material: p.vendor || "Manna Crockery",
      pieces: p.product_type || "Home",
      care: "See product page for care",
      sku: (variant.sku || p.handle || String(p.id)),
      url: `/products/${encodeURIComponent(p.handle || String(p.id))}`
    };
    productMap.set(item.id, item);
    return item;
  }

  function rememberProduct(p) {
    if (!p || !p.id) return;
    productMap.set(p.id, p);
    clearTimeout(rememberProduct._t);
    rememberProduct._t = setTimeout(() => {
      const needed = new Set([...shop.cart.map((i) => i.id), ...shop.wish, ...shop.compare]);
      const slim = {};
      needed.forEach((id) => {
        const item = productMap.get(id);
        if (item) slim[id] = item;
      });
      try {
        localStorage.setItem("mana_products", JSON.stringify(slim));
      } catch (_) {
        /* quota - ignore */
      }
    }, 200);
  }

  function findProduct(id) {
    return productMap.get(id) || products.find((p) => p.id === id) || null;
  }

  function saveShop() {
    localStorage.setItem("mana_cart", JSON.stringify(shop.cart));
    localStorage.setItem("mana_wish", JSON.stringify(shop.wish));
    localStorage.setItem("mana_compare", JSON.stringify(shop.compare));
  }

  function toast(msg) {
    const el = document.getElementById("toast");
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(() => { el.hidden = true; }, 1800);
  }

  function cartCount() {
    return shop.cart.reduce((n, i) => n + i.qty, 0);
  }

  function paintCounts() {
    const map = { wish: shop.wish.length, compare: shop.compare.length, cart: cartCount() };
    document.querySelectorAll("[data-count]").forEach((el) => {
      const n = map[el.dataset.count] || 0;
      el.textContent = n || "";
      el.dataset.empty = n ? "false" : "true";
    });
    document.querySelectorAll(".product").forEach((card) => {
      const id = card.dataset.id;
      card.querySelectorAll('[data-act="wish"]').forEach((el) => el.classList.toggle("is-on", shop.wish.includes(id)));
      card.querySelectorAll('[data-act="compare"]').forEach((el) => el.classList.toggle("is-on", shop.compare.includes(id)));
    });
    document.querySelector('.mana-icons [data-open="wish"], .icons [data-open="wish"]')?.classList.toggle("is-visible", shop.wish.length > 0);
  }

  function toggleList(key, id, limit) {
    const i = shop[key].indexOf(id);
    if (i >= 0) shop[key].splice(i, 1);
    else {
      if (limit && shop[key].length >= limit) {
        toast(`Compare up to ${limit} products`);
        return;
      }
      shop[key].push(id);
    }
    saveShop();
    paintCounts();
  }

  function addCart(id) {
    const row = shop.cart.find((i) => i.id === id);
    if (row) row.qty += 1;
    else shop.cart.push({ id, qty: 1 });
    saveShop();
    paintCounts();
  }

  function removeCart(id) {
    shop.cart = shop.cart.filter((i) => i.id !== id);
    saveShop();
    paintCounts();
  }

  function productCard(p, index = 0) {
    const badge = p.sale
      ? `<span class="badge sale">${p.sale}</span>`
      : (p.badge ? `<span class="badge">${p.badge}</span>` : "");
    const eager = index < 4;
    return `
    <article class="product" data-id="${p.id}">
      ${badge}
      <div class="product__img">
        <a href="${p.url}"><img src="${p.img}" alt="${escapeHtml(p.title)}" ${eager ? `fetchpriority="${index === 0 ? "high" : "auto"}" decoding="async"` : 'loading="lazy" decoding="async"'} width="400" height="400"></a>
        <div class="product__tools">
          <button type="button" class="wish" data-act="wish" aria-label="Add to wishlist" data-tip="Wishlist">${iconHeart}</button>
          <button type="button" data-act="compare" aria-label="Compare products" data-tip="Compare">${iconCmp}</button>
          <button type="button" data-act="book" aria-label="Order now" data-tip="Order now">${iconBook}</button>
        </div>
      </div>
      <div class="product__meta">
        <div class="product__info">
          <h3><a href="${p.url}">${escapeHtml(p.title)}</a></h3>
          <div class="price">${p.compare ? `<span class="old">${p.compare}</span>` : ""}<span class="${p.compare ? "sale-price" : ""}">${p.price}</span></div>
          <div class="stars">★★★★★</div>
        </div>
        <div class="product__buy">
          <button type="button" class="add" data-act="cart">Add to cart</button>
          <button type="button" class="book" data-act="book">Order now</button>
        </div>
      </div>
    </article>`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function countLabel(n) {
    if (!n && n !== 0) return "";
    return n >= 100 ? `${n}+ items` : `${n} items`;
  }

  function hubCard(c) {
    return `<button type="button" class="shop-hub__card" data-hub-main="${escapeHtml(c.handle)}" data-collection="${escapeHtml(c.handle)}" role="listitem">
      <span class="shop-hub__img"><img src="${shopImage(c.img, 240)}" alt="" loading="lazy" decoding="async" width="240" height="240"></span>
      <strong>${escapeHtml((c.title || "").replace(" Collection", ""))}</strong>
      <small>${countLabel(c.count)}</small>
    </button>`;
  }

  function hubSubCard(c) {
    const thumb = c.img
      ? `<span class="shop-hub__sub-img"><img src="${shopImage(c.img, 96)}" alt="" loading="lazy" decoding="async" width="96" height="96"></span>`
      : `<span class="shop-hub__sub-img shop-hub__sub-img--empty" aria-hidden="true"></span>`;
    return `<button type="button" class="shop-hub__sub" data-collection="${escapeHtml(c.handle)}" role="listitem">
      ${thumb}
      <span class="shop-hub__sub-copy">
        <strong>${escapeHtml((c.title || "").replace(" Collection", ""))}</strong>
        <small>${countLabel(c.count)}</small>
      </span>
    </button>`;
  }

  function findDeptForHandle(handle) {
    if (!handle || handle === "all") return null;
    for (const d of departments) {
      if (d.handle === handle) return d;
      if ((d.children || []).some((c) => c.handle === handle)) return d;
    }
    return null;
  }

  function renderHubSubs(mainHandle) {
    const panel = document.querySelector("[data-hub-subs]");
    const grid = document.querySelector("[data-hub-subs-grid]");
    const titleEl = document.querySelector("[data-hub-subs-title]");
    const allBtn = document.querySelector("[data-hub-subs-all]");
    if (!panel || !grid) return;

    const dept = departments.find((d) => d.handle === mainHandle);
    if (!dept) {
      panel.hidden = true;
      grid.innerHTML = "";
      return;
    }

    const kids = dept.children || [];
    panel.hidden = false;
    if (titleEl) titleEl.textContent = `${dept.title} collections`;
    if (allBtn) {
      allBtn.hidden = false;
      allBtn.dataset.collection = dept.handle;
      allBtn.textContent = `Shop all ${dept.title}`;
    }

    if (!kids.length) {
      grid.innerHTML = `<p class="shop-hub__subs-empty">No sub-collections yet. Showing all ${escapeHtml(dept.title)} products below.</p>`;
      return;
    }
    grid.innerHTML = kids.map(hubSubCard).join("");
  }

  function filterItem(c) {
    const thumb = c.img
      ? `<span class="shop-filter__thumb"><img src="${shopImage(c.img, 96)}" alt="" loading="lazy" decoding="async"></span>`
      : `<span class="shop-filter__thumb shop-filter__thumb--empty" aria-hidden="true"></span>`;
    return `<button type="button" class="shop-filter__item" data-collection="${c.handle}">
      ${thumb}
      <span class="shop-filter__item-copy">
        <strong>${escapeHtml((c.title || "").replace(" Collection", ""))}</strong>
        <small>${countLabel(c.count)}</small>
      </span>
      <span class="shop-filter__dot" aria-hidden="true"></span>
    </button>`;
  }

  function setCollection(handle) {
    state.collection = handle || "all";
    state.page = 1;
    syncActiveCollection();
    updateClearVisibility();
    writeState();
    closeFilterDrawer();
    loadProducts();
  }

  function updateClearVisibility() {
    const clear = document.querySelector("[data-filter-clear]");
    if (clear) clear.hidden = state.collection === "all";
  }

  function renderHub() {
    const track = document.querySelector("[data-hub]");
    const mainOrder = ["crockery", "decor", "bedding", "electronics", "luggage-bags"];
    const mains = departments.length
      ? mainOrder
          .map((h) => departments.find((d) => d.handle === h))
          .filter(Boolean)
          .map((d) => ({
            handle: d.handle,
            title: d.title,
            count: d.count,
            img: d.img
          }))
      : collections.filter((c) => c.isMain && c.handle !== "others");
    const hubItems = mains.length ? mains : collections.slice(0, 5);
    if (track) track.innerHTML = hubItems.map(hubCard).join("");

    const list = document.querySelector("[data-filter-list]");
    if (list) {
      if (departments.length) {
        list.innerHTML = departments.map((dept) => {
          const kids = (dept.children || []).map(filterItem).join("");
          return `<div class="shop-filter__dept" data-dept="${escapeHtml(dept.handle)}">
            <button type="button" class="shop-filter__dept-btn" data-collection="${escapeHtml(dept.handle)}">
              <strong>${escapeHtml(dept.title)}</strong>
              <small>${countLabel(dept.count)}</small>
            </button>
            <div class="shop-filter__dept-kids">${kids}</div>
          </div>`;
        }).join("");
      } else {
        list.innerHTML = collections.map(filterItem).join("");
      }
    }

    const parent = findDeptForHandle(state.collection);
    renderHubSubs(parent ? parent.handle : (hubItems[0] && hubItems[0].handle) || "");
    syncActiveCollection();
    updateClearVisibility();
    const total = catalogTotal || collections.filter((c) => c.isMain).reduce((n, c) => n + (c.count || 0), 0);
    document.querySelectorAll("[data-all-count]").forEach((el) => {
      el.textContent = total ? `${total.toLocaleString("en-PK")}+ across store` : "Browse everything";
    });
  }

  function syncActiveCollection() {
    const parent = findDeptForHandle(state.collection);
    document.querySelectorAll("[data-collection]").forEach((el) => {
      el.classList.toggle("is-active", el.dataset.collection === state.collection);
    });
    document.querySelectorAll("[data-hub-main]").forEach((el) => {
      const handle = el.getAttribute("data-hub-main");
      const on =
        handle === state.collection ||
        (parent && parent.handle === handle);
      el.classList.toggle("is-active", !!on);
    });
  }

  async function loadDepartments() {
    const root = document.querySelector("[data-mana-shop]");
    const url = root && root.dataset.departmentsUrl;
    if (!url) return [];
    let liveByHandle = {};
    try {
      const live = await fetch("/collections.json?limit=250", { cache: "no-cache" }).then((r) => r.json());
      for (const c of (live && live.collections) || []) {
        if (c && c.handle) liveByHandle[c.handle] = c.products_count || c.count || 0;
      }
    } catch (_) {}
    try {
      const data = await fetch(url, { cache: "no-cache" }).then((r) => r.json());
      if (!Array.isArray(data)) return [];
      const ai = (typeof window !== "undefined" && window.__manaAiCovers) || {};
      const withLiveCount = (node) => ({
        ...node,
        count: liveByHandle[node.handle] != null ? liveByHandle[node.handle] : Number(node.count) || 0,
        img: ai[node.handle] || node.img,
        children: (node.children || []).map((c) => ({
          ...c,
          count: liveByHandle[c.handle] != null ? liveByHandle[c.handle] : Number(c.count) || 0,
          img: ai[c.handle] || c.img
        }))
      });
      return data.map(withLiveCount);
    } catch (_) {
      return [];
    }
  }

  async function loadCollections() {
    const root = document.querySelector("[data-mana-shop]");
    const assetUrl = root && root.dataset.collectionsUrl;
    let assetRows = [];
    let liveByHandle = {};

    // Live Shopify counts are source of truth (asset JSON can go stale).
    try {
      const live = await fetch("/collections.json?limit=250", { cache: "no-cache" }).then((r) => r.json());
      const list = (live && live.collections) || [];
      for (const c of list) {
        if (!c || !c.handle) continue;
        liveByHandle[c.handle] = {
          handle: c.handle,
          title: c.title,
          count: c.products_count || c.count || 0,
          img: (c.image && (c.image.src || c.image)) || ""
        };
      }
    } catch (_) {}

    if (assetUrl) {
      try {
        const data = await fetch(assetUrl, { cache: "no-cache" }).then((r) => r.json());
        if (Array.isArray(data) && data.length) assetRows = data;
      } catch (_) {}
    }

    if (assetRows.length) {
      return assetRows.map((row) => {
        const live = liveByHandle[row.handle];
        return {
          ...row,
          title: (live && live.title) || row.title,
          count: live ? live.count : Number(row.count) || 0,
          img: row.img || (live && live.img) || ""
        };
      });
    }

    return Object.values(liveByHandle);
  }

  function sortProducts(list, mode) {
    const arr = [...list];
    if (mode === "newest") return arr.sort((a, b) => (b.publishedMs || 0) - (a.publishedMs || 0));
    if (mode === "price-asc") return arr.sort((a, b) => a.amount - b.amount);
    if (mode === "price-desc") return arr.sort((a, b) => b.amount - a.amount);
    if (mode === "az") return arr.sort((a, b) => a.title.localeCompare(b.title));
    if (mode === "za") return arr.sort((a, b) => b.title.localeCompare(a.title));
    return arr;
  }

  function collectionPath(handle) {
    return handle && handle !== "all" ? handle : "all";
  }

  function estimatedTotal(handle) {
    if (handle === "all") {
      // Unique catalog size - never sum collection counts (products overlap).
      return catalogTotal || totalCount || 0;
    }
    const col = collections.find((c) => c.handle === handle);
    return (col && Number(col.count)) || totalCount || 0;
  }

  async function loadCatalogTotal() {
    if (catalogTotal) return catalogTotal;
    const root = document.querySelector("[data-mana-shop]");
    const fromLiquid = Number(root && root.dataset.catalogTotal) || 0;
    if (fromLiquid > 0) {
      catalogTotal = fromLiquid;
      return catalogTotal;
    }
    try {
      const res = await fetch(`${STORE_API}/meta`, { cache: "force-cache" });
      if (res.ok) {
        const meta = await res.json();
        catalogTotal = Number(meta.productsCount) || 0;
      }
    } catch (_) {}
    return catalogTotal;
  }

  async function fetchProductsPage(handle, page, limit, signal) {
    const path = `/collections/${collectionPath(handle)}/products.json?limit=${limit}&page=${page}`;
    let res = await fetch(path, { signal });
    if (!res.ok) res = await fetch(`${STORE}${path}`, { signal });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return (data.products || []).map(normalizeProduct);
  }

  function renderGrid() {
    const grid = document.querySelector("[data-shop-grid]");
    const empty = document.querySelector("[data-shop-empty]");
    const status = document.querySelector("[data-shop-status]");
    const countEl = document.querySelector("[data-result-count]");
    const pagesEl = document.querySelector("[data-shop-pages]");
    if (!grid) return;

    let slice;
    let total;
    let pages;

    if (remotePaging) {
      slice = pageItems;
      const loaded = (state.page - 1) * PAGE_SIZE + pageItems.length;
      total = Math.max(totalCount, loaded);
      if (pageItems.length < PAGE_SIZE) {
        total = loaded;
      } else {
        const est = estimatedTotal(state.collection);
        if (est) total = Math.max(est, loaded);
        else total = Math.max(total, state.page * PAGE_SIZE + 1);
      }
      pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
    } else {
      const sorted = sortProducts(products, state.sort);
      total = sorted.length;
      pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
      if (state.page > pages) state.page = pages;
      const start = (state.page - 1) * PAGE_SIZE;
      slice = sorted.slice(start, start + PAGE_SIZE);
    }

    if (state.page > pages) state.page = pages;

    if (status) status.hidden = true;
    if (empty) empty.hidden = total > 0 && slice.length > 0;
    grid.innerHTML = slice.map((p, i) => productCard(p, i)).join("");
    if (countEl) {
      const label = IS_NEW_PAGE
        ? (state.tab === "deals" ? "Deals" : state.tab === "new" ? "New" : "New & deals")
        : (state.collection === "all"
          ? "All products"
          : (collections.find((c) => c.handle === state.collection)?.title || "Collection"));
      const start = total ? (state.page - 1) * PAGE_SIZE + 1 : 0;
      const end = total ? Math.min(start + slice.length - 1, total) : 0;
      countEl.textContent = total
        ? `Showing ${start}–${end} of ${total.toLocaleString("en-PK")} · ${label}`
        : `0 products · ${label}`;
    }

    if (pagesEl) {
      if (pages <= 1) {
        pagesEl.hidden = true;
        pagesEl.innerHTML = "";
      } else {
        pagesEl.hidden = false;
        const buttons = [];
        buttons.push(`<button type="button" data-page="${state.page - 1}" ${state.page <= 1 ? "disabled" : ""}>Prev</button>`);
        const windowStart = Math.max(1, state.page - 2);
        const windowEnd = Math.min(pages, windowStart + 4);
        for (let i = windowStart; i <= windowEnd; i += 1) {
          buttons.push(`<button type="button" data-page="${i}" class="${i === state.page ? "is-active" : ""}">${i}</button>`);
        }
        buttons.push(`<button type="button" data-page="${state.page + 1}" ${state.page >= pages ? "disabled" : ""}>Next</button>`);
        pagesEl.innerHTML = buttons.join("");
      }
    }

    paintCounts();
    writeState();
  }

  async function fetchCatalogPages(pages, limit, signal) {
    const out = [];
    const seen = new Set();
    for (let page = 1; page <= pages; page += 1) {
      let res = await fetch(`/products.json?limit=${limit}&page=${page}`, { signal });
      if (!res.ok) res = await fetch(`${STORE}/products.json?limit=${limit}&page=${page}`, { signal });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const batch = data.products || [];
      if (!batch.length) break;
      batch.forEach((raw) => {
        const item = normalizeProduct(raw);
        if (seen.has(item.id)) return;
        seen.add(item.id);
        out.push(item);
      });
      if (batch.length < limit) break;
    }
    return out;
  }

  function prepareArrivalsPool(pool) {
    const byDate = [...pool].sort((a, b) => (b.publishedMs || 0) - (a.publishedMs || 0));
    const newestIds = new Set(byDate.slice(0, 48).map((p) => p.id));
    return pool.map((p) => {
      const isNew = newestIds.has(p.id);
      const badge = p.sale ? "" : (isNew ? "New" : "");
      return { ...p, isNew, badge };
    });
  }

  function filterArrivals(list, tab) {
    if (tab === "deals") return list.filter((p) => p.isDeal);
    if (tab === "new") return list.filter((p) => p.isNew);
    // all = newest slice OR on deal
    return list.filter((p) => p.isNew || p.isDeal);
  }

  async function loadNewArrivals() {
    const token = ++fetchToken;
    if (fetchAbort) fetchAbort.abort();
    fetchAbort = new AbortController();
    const { signal } = fetchAbort;

    const grid = document.querySelector("[data-shop-grid]");
    const status = document.querySelector("[data-shop-status]");
    const statusLabel = document.querySelector("[data-shop-status-label]");
    const empty = document.querySelector("[data-shop-empty]");
    if (empty) empty.hidden = true;

    let paintedLocal = false;
    if (!arrivalsPool.length) {
      const local = await loadLocalProductCache();
      if (token !== fetchToken) return;
      if (local && local.length) {
        arrivalsPool = prepareArrivalsPool(local);
        remotePaging = false;
        products = filterArrivals(arrivalsPool, state.tab);
        pageItems = [];
        totalCount = products.length;
        if (status) status.hidden = true;
        renderGrid();
        paintedLocal = true;
      }
    }

    if (!paintedLocal) {
      if (grid) grid.innerHTML = "";
      if (status) {
        status.hidden = false;
        status.classList.remove("is-error");
        if (statusLabel) statusLabel.textContent = "Loading new arrivals";
      }
    }

    try {
      if (!arrivalsPool.length || paintedLocal) {
        const cached = pageCache.get("arrivals|pool");
        const raw = cached || await fetchCatalogPages(4, 50, signal);
        if (token !== fetchToken) return;
        arrivalsPool = prepareArrivalsPool(raw);
        pageCache.set("arrivals|pool", raw);
      }

      remotePaging = false;
      const filtered = filterArrivals(arrivalsPool, state.tab);
      products = filtered;
      pageItems = [];
      totalCount = filtered.length;
      renderGrid();
    } catch (err) {
      if (err && err.name === "AbortError") return;
      if (token !== fetchToken) return;
      if (paintedLocal) return;
      products = [];
      pageItems = [];
      totalCount = 0;
      if (status) {
        status.hidden = false;
        status.classList.add("is-error");
        if (statusLabel) statusLabel.textContent = "Could not load products. Check your connection and try again.";
      }
      if (empty) empty.hidden = true;
    }
  }

  async function loadLocalProductCache() {
    try {
      const root = document.querySelector("[data-mana-shop]");
      const url = (root && root.dataset.productsCacheUrl) || "";
      if (!url) return null;
      const res = await fetch(url, { cache: "force-cache" });
      if (!res.ok) return null;
      const data = await res.json();
      return (data.products || []).map(normalizeProduct);
    } catch (_) {
      return null;
    }
  }

  async function loadProducts() {
    if (IS_NEW_PAGE) {
      await loadNewArrivals();
      return;
    }
    const token = ++fetchToken;
    if (fetchAbort) fetchAbort.abort();
    fetchAbort = new AbortController();
    const { signal } = fetchAbort;

    const grid = document.querySelector("[data-shop-grid]");
    const status = document.querySelector("[data-shop-status]");
    const statusLabel = document.querySelector("[data-shop-status-label]");
    const empty = document.querySelector("[data-shop-empty]");
    if (empty) empty.hidden = true;

    const canUseLocal = state.collection === "all" && state.sort === "featured" && state.page === 1;
    let paintedLocal = false;
    if (canUseLocal) {
      const local = await loadLocalProductCache();
      if (token !== fetchToken) return;
      if (local && local.length) {
        remotePaging = true;
        pageItems = local;
        products = local;
        totalCount = (await loadCatalogTotal()) || local.length;
        if (status) status.hidden = true;
        renderGrid();
        paintedLocal = true;
      }
    }

    if (!paintedLocal) {
      if (grid) grid.innerHTML = "";
      if (status) {
        status.hidden = false;
        status.classList.remove("is-error");
        if (statusLabel) statusLabel.textContent = "Loading products";
      }
    }

    try {
      remotePaging = state.sort === "featured";

      if (remotePaging) {
        const cacheKey = `feat|${state.collection}|${state.page}`;
        let list = pageCache.get(cacheKey);
        if (!list) {
          list = await fetchProductsPage(state.collection, state.page, PAGE_SIZE, signal);
          if (token !== fetchToken) return;
          pageCache.set(cacheKey, list);
        }
        pageItems = list;
        products = list;
        const loaded = (state.page - 1) * PAGE_SIZE + list.length;
        if (state.collection === "all") await loadCatalogTotal();
        if (list.length < PAGE_SIZE) totalCount = loaded;
        else totalCount = estimatedTotal(state.collection) || loaded;
        renderGrid();
        return;
      }

      const poolKey = `pool|${state.collection}`;
      let pool = pageCache.get(poolKey);
      if (!pool) {
        pool = await fetchProductsPage(state.collection, 1, SORT_POOL, signal);
        if (token !== fetchToken) return;
        pageCache.set(poolKey, pool);
      }
      products = pool;
      pageItems = [];
      totalCount = pool.length;
      renderGrid();
    } catch (err) {
      if (err && err.name === "AbortError") return;
      if (token !== fetchToken) return;
      if (paintedLocal) return;
      products = [];
      pageItems = [];
      totalCount = 0;
      if (status) {
        status.hidden = false;
        status.classList.add("is-error");
        if (statusLabel) statusLabel.textContent = "Could not load products. Check your connection and try again.";
      }
      if (empty) empty.hidden = true;
    }
  }

  function renderWish() {
    const box = document.querySelector('[data-list="wish"]');
    const actions = document.querySelector("[data-wish-actions]");
    if (!box) return;
    const rows = shop.wish.map((id) => findProduct(id)).filter(Boolean);
    if (!rows.length) {
      box.innerHTML = "<p>No saved pieces yet.</p>";
      if (actions) actions.innerHTML = "";
      return;
    }
    box.innerHTML = rows.map((p) => `<div class="sheet-row">
      <img src="${p.img}" alt="">
      <div><strong>${escapeHtml(p.title)}</strong><span>${p.price}</span></div>
      <button type="button" data-remove-wish="${p.id}">Remove</button>
    </div>`).join("");
    const names = rows.map((p) => p.title).join(", ");
    const msg = encodeURIComponent(`I would like to enquire about my favorites: ${names}.`);
    if (actions) {
      actions.innerHTML = `
        <a class="btn btn-gold" href="https://wa.me/923114711112?text=${msg}">Enquire on WhatsApp</a>
        <button type="button" class="btn btn-dark" data-wish-cart>Add all to cart</button>`;
    }
  }

  function renderCart() {
    const box = document.querySelector('[data-list="cart"]');
    const foot = document.querySelector("[data-cart-foot]");
    if (!box) return;
    const rows = shop.cart.map((item) => ({ item, p: findProduct(item.id) })).filter((r) => r.p);
    if (!rows.length) {
      box.innerHTML = "<p>Your cart is empty.</p>";
      if (foot) foot.innerHTML = "";
      return;
    }
    box.innerHTML = rows.map(({ item, p }) => `<div class="sheet-row">
      <img src="${p.img}" alt="">
      <div><strong>${escapeHtml(p.title)}</strong><span>${p.price} × ${item.qty}</span></div>
      <button type="button" data-remove-cart="${p.id}">Remove</button>
    </div>`).join("");
    const total = rows.reduce((n, { item, p }) => n + p.amount * item.qty, 0);
    const lines = rows.map(({ item, p }) => `${p.title} × ${item.qty}`).join(", ");
    const msg = encodeURIComponent(`I would like to order: ${lines}. Total ${money(total)}.`);
    if (foot) {
      foot.innerHTML = (typeof window.manaCartFootHTML === "function")
        ? window.manaCartFootHTML(`Total ${money(total)}`, `I would like to order: ${lines}. Total ${money(total)}.`)
        : `<div>Total ${money(total)}</div><div class="sheet__actions"><button type="button" class="btn btn-dark" data-checkout>Checkout</button><a class="btn btn-gold" href="https://wa.me/923114711112?text=${msg}">Order on WhatsApp</a></div>`;
    }
  }

  function renderCompare() {
    const box = document.querySelector('[data-list="compare"]');
    if (!box) return;
    const rows = shop.compare.map((id) => findProduct(id)).filter(Boolean);
    if (!rows.length) {
      compareOpen = false;
      box.innerHTML = "<p>Add products to compare.</p>";
      return;
    }
    const cols = rows.length;
    box.innerHTML = `
      <div class="compare-bar">
        <p>Open these products to see full details in each column, like a product page.</p>
        <button type="button" class="btn ${compareOpen ? "btn-dark" : "btn-gold"}" data-open-pdp>${compareOpen ? "Hide details" : "Open these products"}</button>
      </div>
      <div class="compare-grid" style="--cols:${cols}">${rows.map((p) => {
      const gallery = p.images && p.images.length ? p.images : [p.img];
      return `<article class="compare-card${compareOpen ? " is-open" : ""}">
        <div class="cmp-media" data-cmp-slider data-index="0">
          ${gallery.map((src, i) => `<img class="${i === 0 ? "is-active" : ""}" src="${src}" alt="${escapeHtml(p.title)}">`).join("")}
          <button type="button" class="cmp-media__nav" data-cmp-prev aria-label="Previous image">‹</button>
          <button type="button" class="cmp-media__nav cmp-media__nav--next" data-cmp-next aria-label="Next image">›</button>
          <div class="cmp-media__dots">${gallery.map((_, i) => `<span data-cmp-dot class="${i === 0 ? "is-active" : ""}"></span>`).join("")}</div>
        </div>
        <div class="compare-card__info">
          <strong>${escapeHtml(p.title)}</strong>
          <div class="price">${p.compare ? `<span class="old">${p.compare}</span>` : ""}<span class="${p.compare ? "sale-price" : ""}">${p.price}</span></div>
          <div class="stars">★★★★★</div>
        </div>
        <div class="compare-pdp">
          <p>${escapeHtml(p.desc || "Premium home piece from Manna Crockery.")}</p>
          <dl>
            <div><dt>Brand</dt><dd>${escapeHtml(p.material)}</dd></div>
            <div><dt>Type</dt><dd>${escapeHtml(p.pieces)}</dd></div>
            <div><dt>Care</dt><dd>${escapeHtml(p.care)}</dd></div>
            <div><dt>SKU</dt><dd>${escapeHtml(p.sku)}</dd></div>
          </dl>
        </div>
        <div class="compare-card__actions">
          <button type="button" class="btn btn-dark" data-act="cart" data-id="${p.id}">Add to cart</button>
          <button type="button" class="btn btn-gold" data-remove-compare="${p.id}">Remove</button>
        </div>
      </article>`;
    }).join("")}</div>`;
  }

  function renderBook(id) {
    const p = findProduct(id);
    const box = document.querySelector('[data-list="book"]');
    const actions = document.querySelector("[data-book-actions]");
    if (!p || !box) return;
    const msg = encodeURIComponent(`I want to book ${p.title} (${p.price}) from Manna Crockery.`);
    box.innerHTML = `<div class="sheet-row">
      <img src="${p.img}" alt="">
      <div><strong>${escapeHtml(p.title)}</strong><span>${p.price}</span></div>
    </div>`;
    if (actions) {
      actions.innerHTML = `
        <a class="btn btn-gold" href="https://wa.me/923114711112?text=${msg}">Book on WhatsApp</a>
        <button type="button" class="btn btn-dark" data-act="cart" data-id="${id}">Add to cart</button>`;
    }
  }

  function closeMenu() {
    const nav = document.querySelector("[data-nav]");
    const btn = document.querySelector("[data-menu]");
    if (nav) nav.classList.remove("is-open");
    if (btn) btn.setAttribute("aria-expanded", "false");
  }

  function openSheet(name, id) {
    closeMenu();
    if (name === "wish") renderWish();
    if (name === "cart") renderCart();
    if (name === "compare") renderCompare();
    if (name === "book") renderBook(id);
    document.querySelectorAll(".sheet").forEach((s) => { s.hidden = true; });
    const sheet = document.getElementById(`sheet-${name}`);
    if (sheet) sheet.hidden = false;
  }

  function closeSheets() {
    document.querySelectorAll(".sheet").forEach((s) => { s.hidden = true; });
  }

  /* Menu */
  const menuBtn = document.querySelector("[data-menu]");
  const nav = document.querySelector("[data-nav]");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* Hub collapse */
  const hub = document.querySelector(".shop-hub");
  const hubToggle = document.querySelector("[data-hub-toggle]");
  const hubToggleLabel = document.querySelector("[data-hub-toggle-label]");
  const hubHint = document.querySelector("[data-hub-hint]");
  let setHubCollapsed = () => {};
  if (!IS_NEW_PAGE && hubToggle && hub) {
    const stopPulse = () => hubToggle.classList.remove("is-pulse");
    const setHubHint = (collapsed) => {
      if (!hubHint) return;
      hubHint.innerHTML = collapsed
        ? `Categories hidden. Click <strong>Show collections</strong> to browse again.`
        : `Pick a main category, then choose a sub-collection.`;
    };
    setHubCollapsed = (collapsed) => {
      hub.classList.toggle("is-collapsed", collapsed);
      hubToggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
      if (hubToggleLabel) hubToggleLabel.textContent = collapsed ? "Show collections" : "Hide collections";
      setHubHint(collapsed);
      if (collapsed) stopPulse();
      try {
        sessionStorage.setItem("mana_shop_hub_collapsed", collapsed ? "1" : "0");
      } catch (_) {}
    };
    // Default open; remember if user hid collections this session
    let startCollapsed = false;
    try {
      startCollapsed = sessionStorage.getItem("mana_shop_hub_collapsed") === "1";
    } catch (_) {}
    setHubCollapsed(startCollapsed);
    if (startCollapsed) {
      requestAnimationFrame(() => hubToggle.classList.add("is-pulse"));
      hubToggle.addEventListener("animationend", (e) => {
        if (e.animationName === "hubTogglePulse") stopPulse();
      });
    }
    hubToggle.addEventListener("click", () => {
      stopPulse();
      setHubCollapsed(!hub.classList.contains("is-collapsed"));
    });
  }

  function revealProducts() {
    const target = document.querySelector("#products") || document.querySelector(".shop-main");
    if (!target) return;
    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  function openFilterDrawer() {
    document.querySelector("[data-filter-panel]")?.classList.add("is-open");
    const backdrop = document.querySelector("[data-filter-backdrop]");
    if (backdrop) backdrop.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeFilterDrawer() {
    document.querySelector("[data-filter-panel]")?.classList.remove("is-open");
    const backdrop = document.querySelector("[data-filter-backdrop]");
    if (backdrop) backdrop.hidden = true;
    document.body.style.overflow = "";
  }

  document.querySelector("[data-filter-open]")?.addEventListener("click", openFilterDrawer);
  document.querySelector("[data-filter-backdrop]")?.addEventListener("click", closeFilterDrawer);

  document.querySelector("[data-filter-clear]")?.addEventListener("click", () => setCollection("all"));

  document.querySelector("[data-filter-search]")?.addEventListener("input", (e) => {
    const q = e.target.value.trim().toLowerCase();
    document.querySelectorAll("[data-filter-list] [data-collection]").forEach((el) => {
      const title = (el.querySelector("strong")?.textContent || "").toLowerCase();
      el.hidden = q ? !title.includes(q) : false;
    });
  });

  /* Collection select - hub mains/subs + filter (hub stays open; user can Hide manually) */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-collection]");
    if (!btn || !btn.closest("[data-hub], [data-hub-subs], [data-filter-panel]")) return;
    const handle = btn.dataset.collection || "all";
    const isHubMain = btn.hasAttribute("data-hub-main");
    if (isHubMain) {
      renderHubSubs(handle);
    } else {
      const parent = findDeptForHandle(handle);
      if (parent) renderHubSubs(parent.handle);
    }
    setCollection(handle);
    revealProducts();
  });

  /* Hub main hover previews sub-collections without changing product grid yet */
  document.addEventListener("mouseover", (e) => {
    const main = e.target.closest("[data-hub-main]");
    if (!main || !main.closest("[data-hub]")) return;
    renderHubSubs(main.getAttribute("data-hub-main"));
    document.querySelectorAll("[data-hub-main]").forEach((el) => {
      el.classList.toggle("is-active", el === main || el.dataset.collection === state.collection);
    });
  });

  /* Mega menu → open that collection on this page */
  window.addEventListener("mana:set-collection", (e) => {
    const handle = (e.detail && e.detail.handle) || "all";
    setCollection(handle);
    revealProducts();
  });

  if (state.collection !== "all") {
    requestAnimationFrame(() => revealProducts());
  }

  /* Sort */
  const sortEl = document.querySelector("[data-sort]");
  if (sortEl) {
    sortEl.value = state.sort;
    sortEl.addEventListener("change", () => {
      state.sort = sortEl.value;
      state.page = 1;
      loadProducts();
    });
  }

  /* New arrivals tabs */
  const tabsRoot = document.querySelector("[data-new-tabs]");
  if (tabsRoot && IS_NEW_PAGE) {
    const syncTabs = () => {
      tabsRoot.querySelectorAll("[data-tab]").forEach((btn) => {
        const on = btn.dataset.tab === state.tab;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-selected", on ? "true" : "false");
      });
    };
    syncTabs();
    tabsRoot.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-tab]");
      if (!btn) return;
      state.tab = btn.dataset.tab || "all";
      state.page = 1;
      syncTabs();
      loadProducts();
    });

    document.querySelectorAll("[data-tab-jump]").forEach((link) => {
      link.addEventListener("click", () => {
        const tab = link.getAttribute("data-tab-jump") || "all";
        state.tab = tab;
        state.page = 1;
        syncTabs();
        loadProducts();
      });
    });
  }

  /* Pagination */
  document.querySelector("[data-shop-pages]")?.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-page]");
    if (!btn || btn.disabled) return;
    const page = Number(btn.dataset.page);
    if (!page || page < 1) return;
    state.page = page;
    if (remotePaging) loadProducts();
    else renderGrid();
    document.querySelector("#products")?.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* Product actions */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".product [data-act]");
    if (!btn) return;
    const card = btn.closest(".product");
    const id = card.dataset.id;
    const act = btn.dataset.act;
    const p = findProduct(id);
    if (p) rememberProduct(p);
    if (act === "wish") {
      toggleList("wish", id);
      toast(shop.wish.includes(id) ? "Saved to wishlist" : "Removed from wishlist");
    }
    if (act === "compare") {
      toggleList("compare", id, 3);
      if (shop.compare.includes(id)) toast("Added to compare");
    }
    if (act === "cart") {
      addCart(id);
      toast("Added to cart");
    }
    if (act === "book") openSheet("book", id);
  });

  document.querySelectorAll("[data-open]").forEach((btn) => {
    btn.addEventListener("click", () => openSheet(btn.dataset.open));
  });
  document.querySelectorAll("[data-close]").forEach((btn) => {
    btn.addEventListener("click", closeSheets);
  });

  document.querySelectorAll(".sheet").forEach((sheet) => {
    sheet.addEventListener("click", (e) => {
      if (e.target === sheet) closeSheets();
      const wishId = e.target.dataset.removeWish;
      const cartId = e.target.dataset.removeCart;
      const cmpId = e.target.dataset.removeCompare;
      if (wishId) { shop.wish = shop.wish.filter((id) => id !== wishId); saveShop(); paintCounts(); renderWish(); }
      if (cartId) { removeCart(cartId); renderCart(); }
      if (cmpId) { shop.compare = shop.compare.filter((id) => id !== cmpId); saveShop(); paintCounts(); renderCompare(); }
      const act = e.target.closest("[data-act]");
      if (act && act.dataset.act === "cart") {
        addCart(act.dataset.id);
        toast("Added to cart");
        renderCart();
      }
      if (e.target.closest("[data-wish-cart]")) {
        shop.wish.forEach((id) => addCart(id));
        toast("Favorites added to cart");
        renderCart();
      }
      if (e.target.closest("[data-open-pdp]")) {
        compareOpen = !compareOpen;
        renderCompare();
      }
      const sliderBtn = e.target.closest("[data-cmp-prev], [data-cmp-next]");
      if (sliderBtn) {
        const root = sliderBtn.closest("[data-cmp-slider]");
        const slides = [...root.querySelectorAll("img")];
        let i = Number(root.dataset.index || 0);
        i = (i + (sliderBtn.hasAttribute("data-cmp-next") ? 1 : -1) + slides.length) % slides.length;
        root.dataset.index = String(i);
        slides.forEach((img, n) => img.classList.toggle("is-active", n === i));
        root.querySelectorAll("[data-cmp-dot]").forEach((dot, n) => dot.classList.toggle("is-active", n === i));
      }
    });
  });

  /* Search */
  const searchRoot = document.getElementById("search");
  const searchInput = document.getElementById("search-input");
  const searchBox = document.querySelector("[data-search-results]");
  let searchTimer = 0;
  let searchToken = 0;

  function moneyFromShopify(price) {
    const n = Number(price);
    if (!Number.isFinite(n)) return "";
    const value = n > 9999 ? Math.round(n / 100) : n;
    return `Rs.${value.toLocaleString("en-PK")}`;
  }

  function searchRow(item) {
    return `<a class="search-row" href="${item.url}">
      <img src="${item.img}" alt="">
      <div><strong>${escapeHtml(item.title)}</strong><small>${item.price || item.type}</small></div>
      <em>${item.type}</em>
    </a>`;
  }

  async function liveSearch(q) {
    const path = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8`;
    let res = await fetch(path);
    if (!res.ok) res = await fetch(`${STORE}${path}`);
    const data = await res.json();
    const productsLive = (((data.resources || {}).results || {}).products || []).map((p) => ({
      title: p.title,
      url: `/products/${encodeURIComponent(p.handle || String(p.url || "").split("/").pop())}`,
      img: shopImage(p.image || ""),
      price: moneyFromShopify(p.price),
      type: "Product"
    }));
    const collectionsLive = (((data.resources || {}).results || {}).collections || []).map((c) => ({
      title: c.title,
      url: `/collections/all?collection=${encodeURIComponent(c.handle || "")}`,
      img: shopImage(c.featured_image?.url || c.image || ""),
      price: "",
      type: "Collection"
    }));
    return [...productsLive, ...collectionsLive];
  }

  /* Search open/close lives in mana-header.js — only bind live results here if header did not */
  if (!window.__manaSearchBound) {
    window.__manaSearchBound = true;
    const setOpen = (open) => {
      if (!searchRoot) return;
      searchRoot.hidden = !open;
      document.documentElement.classList.toggle("mana-search-open", open);
      document.body.classList.toggle("mana-search-open", open);
      if (open) searchInput?.focus();
    };
    document.querySelector("[data-open-search]")?.addEventListener("click", () => setOpen(true));
    document.querySelector("[data-close-search]")?.addEventListener("click", () => setOpen(false));
    searchRoot?.addEventListener("click", (e) => {
      if (e.target === searchRoot) setOpen(false);
    });
    searchInput?.addEventListener("input", () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      const suggest = document.querySelector("[data-search-suggest]");
      const clearBtn = document.querySelector("[data-search-clear]");
      if (suggest) suggest.hidden = !!q;
      if (clearBtn) clearBtn.hidden = !q;
      if (!q) {
        if (searchBox) searchBox.innerHTML = "";
        return;
      }
      searchTimer = setTimeout(async () => {
        const token = ++searchToken;
        try {
          const rows = await liveSearch(q);
          if (token !== searchToken || !searchBox) return;
          searchBox.innerHTML = rows.length
            ? rows.map(searchRow).join("")
            : `<p class="search-empty">No matches for “${escapeHtml(q)}”.</p>`;
        } catch (_) {
          if (token !== searchToken || !searchBox) return;
          searchBox.innerHTML = `<p class="search-empty">Search unavailable right now.</p>`;
        }
      }, 280);
    });
  }

  paintCounts();

  (async () => {
    if (IS_NEW_PAGE) {
      await loadProducts();
      return;
    }
    departments = await loadDepartments();
    collections = await loadCollections();
    if (departments.length && (!collections.length || !collections.some((c) => c.isMain))) {
      collections = departments.flatMap((d) => [
        { handle: d.handle, title: d.title, count: d.count, img: d.img, department: d.title, isMain: true },
        ...(d.children || []).map((c) => ({ ...c, department: d.title, isMain: false }))
      ]);
    }
    await loadCatalogTotal();
    renderHub();
    if (state.collection !== "all" && !collections.some((c) => c.handle === state.collection)) {
      state.collection = "all";
    }
    syncActiveCollection();
    updateClearVisibility();
    await loadProducts();
  })();
  window.renderWish = renderWish;
  window.renderCart = renderCart;
  window.renderCompare = renderCompare;
  window.renderBook = renderBook;
})();
